/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiScreeningManualSearchConfiguration } from './InternalApiScreeningManualSearchConfiguration';
import {
    InternalApiScreeningManualSearchConfigurationFromJSON,
    InternalApiScreeningManualSearchConfigurationFromJSONTyped,
    InternalApiScreeningManualSearchConfigurationToJSON,
    InternalApiScreeningManualSearchConfigurationToJSONTyped,
} from './InternalApiScreeningManualSearchConfiguration';

/**
 * 
 * @export
 * @interface InternalApiScreeningManualSearch
 */
export interface InternalApiScreeningManualSearch {
    /**
     * Screened value
     * @type {string}
     * @memberof InternalApiScreeningManualSearch
     */
    value: string;
    /**
     * Record type
     * @type {InternalApiScreeningManualSearchRecordEntityTypeEnum}
     * @memberof InternalApiScreeningManualSearch
     */
    recordEntityType?: InternalApiScreeningManualSearchRecordEntityTypeEnum;
    /**
     * 
     * @type {Array<InternalApiScreeningManualSearchConfiguration>}
     * @memberof InternalApiScreeningManualSearch
     */
    configurations: Array<InternalApiScreeningManualSearchConfiguration>;
}

/**
* @export
* @enum {string}
*/
export enum InternalApiScreeningManualSearchRecordEntityTypeEnum {
    PERSON = 'PERSON',
    ENTITY = 'ENTITY',
    ALL = 'ALL'
}


/**
 * Check if a given object implements the InternalApiScreeningManualSearch interface.
 */
export function instanceOfInternalApiScreeningManualSearch(value: object): value is InternalApiScreeningManualSearch {
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('configurations' in value) || value['configurations'] === undefined) return false;
    return true;
}

export function InternalApiScreeningManualSearchFromJSON(json: any): InternalApiScreeningManualSearch {
    return InternalApiScreeningManualSearchFromJSONTyped(json, false);
}

export function InternalApiScreeningManualSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScreeningManualSearch {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
        'recordEntityType': json['recordEntityType'] == null ? undefined : json['recordEntityType'],
        'configurations': ((json['configurations'] as Array<any>).map(InternalApiScreeningManualSearchConfigurationFromJSON)),
    };
}

export function InternalApiScreeningManualSearchToJSON(json: any): InternalApiScreeningManualSearch {
    return InternalApiScreeningManualSearchToJSONTyped(json, false);
}

export function InternalApiScreeningManualSearchToJSONTyped(value?: InternalApiScreeningManualSearch | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': value['value'],
        'recordEntityType': value['recordEntityType'],
        'configurations': ((value['configurations'] as Array<any>).map(InternalApiScreeningManualSearchConfigurationToJSON)),
    };
}

